<template>
  <div v-if="show" class="join-modal">
    <div @click="closeModal" class="join-modal-close close"></div>
    <div   class="join-modal-content">
      <div class="join-modal-content-headline">
        {{show_login_form ? trans('home.log_in') : trans('home.sign_up_now')}}
      </div>
      <div v-if="!show_login_form" class="join-modal-content-text">
        <p>{{trans("join_modal.become_a_member")}}</p>
        <p>{{trans("join_modal.its_quick_and_free")}}</p>
      </div>
      <div v-if="!show_login_form"  class="join-modal-content-footer">
        <button @click="goToRegisterPage" class="btn btn-primary button-create-account">{{trans("home.create_account")}}</button>
        <p>{{trans("join_modal.already_a_member")}}</p>
        <button @click="openLoginForm" class="btn btn-default">{{trans("home.log_in")}}</button>
      </div>
    </div>
    <Login v-if="show_login_form"/>
    <div v-if="show_login_form" class="join-box">
      <div class="title">{{ trans('home.new_here') }}</div>
      <a @click="goToRegisterPage" class="btn btn-default">{{ trans('home.create_account') }}</a>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import Login from "@buddy/views/new/widgets/Login";

export default {
  components: {
    Login
  },
  mixins: [require('@general/lib/mixin').default],
  methods: {
    openLoginForm(){
      this.show_login_form = true;
    },
    closeModal(){
      this.show_login_form = false;
      this.closeJoinModal();
    }
  },
  computed: {
    ...mapState({
      show: state => state.modal.join,
    }),
  },
  data(){
    return {
      show_login_form: false
    }
  },
  mounted() {

  }
}
</script>
